/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type StateEnum = (typeof StateEnum)[keyof typeof StateEnum];

export const StateEnum = {
  active: 'active',
  precommit: 'precommit',
  completed: 'completed',
} as const;
